// Used in style to get a default value if nothing is passed
export const defaultIfNoValue = (
  defaultValue: number,
  value?: number
): number => {
  if (value === null || value === undefined) {
    return defaultValue
  }
  return value
}
